/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Builder_TitleInputs */

const en_cp_builder_title = /** @type {(inputs: Cp_Builder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder`)
};

const id_cp_builder_title = /** @type {(inputs: Cp_Builder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder`)
};

/**
* | output |
* | --- |
* | "Builder" |
*
* @param {Cp_Builder_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_builder_title = /** @type {((inputs?: Cp_Builder_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Builder_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_builder_title(inputs)
	return en_cp_builder_title(inputs)
});